import { api } from '@/lib/api';
import type {
  FaultRoster,
  FaultRosterMemberRef,
  SetFaultMarksPayload,
  TicketFaultMarks
} from '@/types/api';

/**
 * V4.9.19 — Manual multi-party fault API.
 * Roster reads are open to any authenticated user (needed to render the
 * picker); roster writes are admin-only; setting marks is Admin or the
 * ticket's assigned Solver (enforced server-side).
 */
export const faultApi = {
  // Roster (admins pass all=true to include deactivated members).
  roster: (all = false) =>
    api.get<FaultRoster>('/fault-roster', all ? { params: { all: '1' } } : undefined),
  addMember: (team: string, name: string) =>
    api.post<FaultRosterMemberRef>('/fault-roster', { team, name }),
  updateMember: (
    id: string,
    patch: { name?: string; active?: boolean; display_order?: number }
  ) => api.patch<FaultRosterMemberRef>(`/fault-roster/${id}`, patch),
  deleteMember: (id: string) =>
    api.delete<{ success: true; id: string; name: string; team: string }>(`/fault-roster/${id}`),

  // Per-ticket marks.
  getMarks: (ticketId: string) =>
    api.get<TicketFaultMarks>(`/tickets/${ticketId}/fault-marks`),
  setMarks: (ticketId: string, payload: SetFaultMarksPayload) =>
    api.put<TicketFaultMarks>(`/tickets/${ticketId}/fault-marks`, payload)
};
